import React from 'react';

export interface YouTubePlayerProps {
  videoId: string;
  title?: string;
  description?: string;
  width?: string;
  height?: string;
}

const YouTubePlayer: React.FC<YouTubePlayerProps> = ({
  videoId,
  title,
  description,
  width = '100%',
  height = '315',
}) => {
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className="youtube-player-container">
      <div className="ratio ratio-16x9 mb-3">
        <iframe
          width={width}
          height={height}
          src={embedUrl}
          title={title || 'YouTube video player'}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{ borderRadius: '15px' }}
        />
      </div>
      {title && (
        <h5 className="fw-bold text-gray-800 mb-2" style={{ textTransform: 'unset' }}>
          {title}
        </h5>
      )}
      {description && <p className="text-gray-600 fs-6">{description}</p>}
    </div>
  );
};

export default YouTubePlayer;
